import options from './tabs.component';

export default {
    selector: 'dtSensorTabs',
    options
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/tabs/index.js